module.exports = __webpack_public_path__ + "img/gb921.prt.6d458311.jpg";